/*
 * assets/video-player.js
 * One-time global initializer for all video-player snippets.
 * Reads poster URLs from data attributes set in the snippet markup.
 * Features:
 *  - Picks optimal poster (640 / 1280 / 1920) based on container width × devicePixelRatio
 *  - Enables click-to-play functionality
 *  - Idempotent: initializes only uninitialized videos
 *  - Handles Shopify Theme Editor section events
 */
(function(){
  window.Hanso = window.Hanso || {};
  if (window.Hanso.videoPlayer && window.Hanso.videoPlayer._loaded) return;

  function pickPoster(video){
    try {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = (video.clientWidth || video.offsetWidth || 0) * dpr;
      var wrap = video.parentElement;
      var p640  = video.getAttribute('data-poster-640')  || (wrap && wrap.getAttribute('data-poster-640'));
      var p1280 = video.getAttribute('data-poster-1280') || (wrap && wrap.getAttribute('data-poster-1280'));
      var p1920 = video.getAttribute('data-poster-1920') || (wrap && wrap.getAttribute('data-poster-1920'));
      var target = p640;
      if (w > 1100 && p1920) target = p1920;
      else if (w > 700 && p1280) target = p1280;
      if (target && video.poster !== target && video.paused) video.poster = target;
    } catch(e){}
  }


  function init(root){
    root = root || document;
    var wrappers = root.querySelectorAll('[data-click-to-play]');
    wrappers.forEach(function(wrapper){
      var video = wrapper.querySelector('.video-element');
      let overlay_elem = wrapper.querySelector(`.video-play-overlay`);
      if (!video || video.dataset.hansoInitialized === '1') return;
      video.dataset.hansoInitialized = '1';

      // Poster sizing as before
      pickPoster(video);
      try { if ('ResizeObserver' in window) { new ResizeObserver(function(){ pickPoster(video); }).observe(wrapper); } } catch(e){}

      // Click-to-play (whole container)
      var playHandler = function(){ 
        console.warn(`video: `, video);
        console.warn(`video is paused: `, video.paused);
        if (video.paused) video.play(); 
      };
      overlay_elem.addEventListener('click', playHandler);
      // video.addEventListener('click', playHandler);

      // Overlay toggle
      var setOverlay = function(){
        console.warn(`elem clicked: `, this, video.paused);
        if (video.seeking) return false;
        if (video.paused) {
          wrapper.classList.remove('is-playing');
          video.removeAttribute(`controls`);
        }
        else {
          wrapper.classList.add('is-playing');
          video.setAttribute(`controls`, true);
        }
      };
      setOverlay();
      video.addEventListener('play', setOverlay);
      video.addEventListener('pause', setOverlay);
      video.addEventListener('ended', setOverlay);

      // Optional: keyboard accessibility (Space/Enter on wrapper)
      wrapper.setAttribute('tabindex','0');
      wrapper.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (video.paused) video.play(); else video.pause();
        }
      }, {passive:false});
    });
  }

  window.Hanso.videoPlayer = { init: init, _loaded: true };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:section:reorder', function(){ init(document); });
  document.addEventListener('shopify:block:select', function(e){ init(e.target); });
})();